/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */
import _parseInt from "@babel/runtime-corejs3/core-js-stable/parse-int";

/** @module core/modules/object-utils/path-to-key */
import { isArrayPath } from './is-array-path.js';
/**
 * @description Converts the passed path segment to a key of correct type depending on format.
 * @param {string} str - Path string containing key.
 * @returns {(string|number)} Object<string,*> key.
 */

function pathToKey(str) {
  if (isArrayPath(str)) {
    return _parseInt(str.replace(/^\[|]$/g, ''));
  } else {
    return str.replace(/^\[|]$/g, '');
  }
}

export { pathToKey };